import { Component, OnInit, ElementRef } from '@angular/core';
import { MiraieService } from '../Services/miraie.service';
import { ReportService } from '../Services/report.service';
import { StatusService } from '../Services/status.service';
import { AuthService } from '../Services/auth.service';
import { OutputService } from '../Services/output.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})

export class ReportComponent implements OnInit {
  logininfo: Logininfo = this.Auth.loginID;
  user_code: number;
  year: number;
  month: number;
  week: number;
  srcurl: string;

  //部長権限
  authDirector = false;

  weeklyReport;
  result: {
    intro_actual: number,
    new_actual: number,
    ap_actual: number,
    app_result: number,
    contract_record: number;
  }
  monthly: {
    intro_actual: number,
    new_actual: number,
    ap_actual: number,
    app_result: number,
    contract_record: number;
    intro_target: number,
    new_target: number,
    ap_target: number,
    app_target: number,
    contract_target: number,
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private miraieService: MiraieService,
    private reportSerivice: ReportService,
    private statusService: StatusService,
    public Auth: AuthService,
    private outputService: OutputService,
  ) {
    this.user_code = +this.route.snapshot.paramMap.get('user_code');
    this.year = +this.route.snapshot.paramMap.get('year');
    this.month = +this.route.snapshot.paramMap.get('month');
    this.week = +this.route.snapshot.paramMap.get('week');
    if (this.year == 0) this.year = new Date().getFullYear();
    if (this.month == 0) this.month = new Date().getMonth() + 1;
    if (this.week == 0) this.week = this.getWeekNum();
  }

  ngOnInit() {
    if (this.user_code == 0) {
      this.user_code = this.logininfo.user_code;
    }
    this.srcurl = this.miraieService.srcurl;
    var auth = this.Auth.getAuthority();
    //console.log(auth['Auth']);
    if (auth['Auth'] == "GENERAL") {
      this.authDirector = true;
    }

    this.result = {
      intro_actual: 0,
      new_actual: 0,
      ap_actual: 0,
      app_result: 0,
      contract_record: 0
    };
    this.monthly = {
      intro_actual: 0,
      new_actual: 0,
      ap_actual: 0,
      app_result: 0,
      contract_record: 0,
      intro_target: 0,
      new_target: 0,
      ap_target: 0,
      app_target: 0,
      contract_target: 0,
    };
    this.getPersonalStatus();
    this.getWeeklyReport();

  }

  //年月変更
  change() {
    this.getPersonalStatus();
    this.getWeeklyReport();
  }

  //本日の週番号取得
  getWeekNum() {
    let today = new Date();

    if (today.getDay() > 1) {
      today.setDate(today.getDate() - today.getDay() + 1);
    } else if (today.getDay() == 0) {
      today.setDate(today.getDate() - 6);
    }

    let oneday = new Date(this.year, this.month - 1, 1);
    if (oneday > today) {
      if (this.month == 1) {
        this.month = 12;
        this.year -= 1;
      } else {
        this.month -= 1;
      }
      oneday = new Date(this.year, this.month - 1, 1);
    }

    if (oneday.getDay() > 1) {
      oneday.setDate(oneday.getDate() + (8 - oneday.getDay()));
    } else if (oneday.getDay() == 0) {
      oneday.setDate(oneday.getDate() + 1);
    }

    let weeknum = Math.floor((today.getDate() - oneday.getDate()) / 7 + 1);
    return weeknum;
  }

  //週報取得
  getWeeklyReport() {
    this.weeklyReport = null;

    this.reportSerivice.getWeeklyReport(this.user_code, this.year, this.month, this.week).subscribe(
      res => {
        if (res != null) {
          this.weeklyReport = res;
        }
      });
  }

  getPersonalStatus() {
    this.statusService.getPersonalStatus(this.user_code, this.year, this.month, this.week).subscribe(res => {
      if (res != undefined) {
        this.result = {
          intro_actual: res['intro_actual'],
          new_actual: res['new_actual'],
          ap_actual: res['ap_actual'],
          app_result: res['app_result'],
          contract_record: res['contract_record']
        };
      }
    });
    this.statusService.getPersonalStatus(this.user_code, this.year, this.month, 0).subscribe(res => {
      if (res != undefined) {
        //console.log(res);
        this.monthly = {
          intro_actual: res['intro_actual'],
          new_actual: res['new_actual'],
          ap_actual: res['ap_actual'],
          app_result: res['app_result'],
          contract_record: res['contract_record'],
          intro_target: res['intro_target'],
          new_target: res['new_target'],
          ap_target: res['ap_target'],
          app_target: res['app_target'],
          contract_target: res['contract_target'],
        };
      }
    });
  }

  //編集ページへ
  edit(i) {
    this.reportSerivice.anchor = i;
    this.router.navigate(['/report-edit', this.user_code, this.year, this.month, this.week], { relativeTo: this.route });
  }


  save() {
    this.reportSerivice.updateWeeklyReport(this.weeklyReport).subscribe(res => {
      this.router.navigate(['/report-list'], { relativeTo: this.route });
    });
  }

  //一覧へ戻る
  backList() {
    this.router.navigate(['/report-list/']);
  }

  //Excel出力
  output() {
    let res = this.outputService.weeklyReport(this.weeklyReport, this.result, this.monthly)
    res.subscribe(res => {
      const url = this.srcurl + "output/report/" + this.weeklyReport.user_code + "/週報_" + this.weeklyReport.user_family_name + "_" + this.weeklyReport.year + "年" + this.weeklyReport.month + "月" + this.weeklyReport.week + "週目.xlsx";
      window.open(url);
    });
  }

  customTrackBy(index: number, obj: any): any {
    return index;
  }

  parsent(num1: number, num2: number) {
    let result = num1 / num2 * 100;
    return Math.floor(result * 100) / 100;
  }
}
